import { render } from "./Service-box.component.vue?vue&type=template&id=2906058a&ts=true"
import script from "./Service-box.component.vue?vue&type=script&lang=ts"
export * from "./Service-box.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__